<template lang="html">
   <div class="layout-sidenav icons-only">
      <div class="app-loader" v-show="showLoader">
         <div class="center-text">
				<img src="/img/logo.svg" alt="" class="flick logo">
         </div>
		</div>

      <div class="main-body">
         <!-- <slot name="top-nav"></slot> -->
         <TopNav />

         <div class="content clearfix">
            <transition mode="out-in">
               <router-view/>
            </transition>
         </div>
         
         <CustomFooter/>
      </div>

      <SideNav :routes="routes"/> 
   </div>
</template>

<script>
import 'wino-template/styles/layouts/index.scss'
import layout from "./layout.store";
import routes from '@/router/nav'

export default {
   beforeDestroy () {
      this.$store.unregisterModule('layout')
      Event.$off('loader:show')
   },
   created(){
      Event.$on('loader:show',(status)=>{
			this.showLoader = status
		})

      utils.registerModule('layout',layout,this.$store)
   },
   components: {
      SideNav: () => import(`wino-template/components/side-nav`),
      TopNav: () => import(`./top-nav`),
      CustomFooter: () => import(`./footer`),
   },
   computed: {
      ...mapGetters([
         'loading',
      ])
   },
   data () {
      return {
         routes,
         showLoader: true,
         user: {},
      }
   },
   methods: {
      ...mapActions([
         'logOut',
         // 'resetPassword',
         // 'clickAction',
         // 'submitUpdate',
         // 'fetchFormData',
      ]),
   },
   mounted(){
      utils.registerModule('layout',layout,this.$store)
   },
}
</script>

<style lang="scss">
   .layout-sidenav{
   }
</style>